import * as React from 'react';
import {
    List,
    Datagrid,
    BooleanInput,
    BooleanField,
    DateField,
    TextField,
    SearchInput,
    TextInput,
    TopToolbar,
    FilterButton,
    ExportButton,
    ReferenceInput,
    AutocompleteInput,
} from 'react-admin';
import { useMediaQuery, Theme } from '@mui/material';

import MobileGrid from './MobileGrid';

const entityFilters = [
    <SearchInput source="q" alwaysOn />,
    <BooleanInput source="template_from" alwaysOn />,
    <BooleanInput source="template_to" alwaysOn />,
    <ReferenceInput
        source="city_item_from_id"
        reference="logix_cities"
        alwaysOn
    >
        <AutocompleteInput optionText="title_selector" fullWidth />
    </ReferenceInput>,
    <ReferenceInput source="city_item_to_id" reference="logix_cities" alwaysOn>
        <AutocompleteInput optionText="title_selector" fullWidth />
    </ReferenceInput>,
    <TextInput source="title" />,
    <TextInput source="slug" />,
    <BooleanInput source="active" />,
];

const ListActions = () => (
    <TopToolbar>
        <FilterButton />
        <ExportButton />
    </TopToolbar>
);

const EntityList = () => {
    const isXsmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    // const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    return (
        // @ts-ignore
        <List
            actions={<ListActions />}
            filters={entityFilters}
            sort={{ field: 'slug', order: 'DESC' }}
            perPage={25}
        >
            {isXsmall ? (
                <MobileGrid />
            ) : (
                <Datagrid
                    optimized
                    rowClick="edit"
                    sx={{
                        '& .column-groups': {
                            md: { display: 'none' },
                            lg: { display: 'table-cell' },
                        },
                    }}
                >
                    <BooleanField source="template_from" />
                    <BooleanField source="template_to" />
                    <TextField source="city_item_from.title" />
                    <TextField source="city_item_to.title" />
                    <TextField source="title" />
                    <TextField source="slug" />
                    <BooleanField source="active" />
                    <DateField source="created" showTime={true} />
                    <DateField source="modified" showTime={true} />
                </Datagrid>
            )}
        </List>
    );
};

export default EntityList;
